import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';

/* components */
import { Icon, Label } from '@tcc/crate';

const long = 'long';

const status = {
  danger: 'danger',
  success: 'success'
};

export const TagIcon = ({ backupNumber, isPrimary, score }) => {
  const testId = 'crate-label';

  if (isPrimary) {
    return (
      <Label
        length={long}
        status={status.success}
        testId={`${testId}-${status.success}-primary`}>
        {getMessage('label-text__primary-flag')}  <Icon glyph={Icon.set.STAR} />
      </Label>
    );
  } else if (score >= 0 && backupNumber) {
    return (
      <Label
        length={long}
        status={status.success}
        testId={`${testId}-${status.success}-backup`}>
        {getMessage('label-text__backup-flag', { num: backupNumber })}
      </Label>
    );
  } else if (score < 0) {
    return (
      <Label
        length={long}
        status={status.danger}
        testId={`${testId}-${status.danger}-doNotPlant`}>
        {getMessage('label-text__do-not-plant-flag')}
      </Label>
    );
  } else {
    return null;
  }
};

export const TestedIcon = () => (
  <div>
    <span className='isTested'>{getMessage('label-text__tested')}</span>
  </div>
);

// TODO break these out into their own separate files
// eslint-disable-next-line react/no-multi-comp
const SelectOptionsIcon = ({
  backupNumber,
  isPrimary,
  score,
  tested
}) => {

  /* prefer showing seed recommendations over tested label */
  if (score || score === 0) {
    return (
      <TagIcon
        backupNumber={backupNumber}
        isPrimary={isPrimary}
        score={score}
      />
    );
  }

  if (tested) {
    return <TestedIcon />;
  }

  return null;
};

TagIcon.propTypes = {
  backupNumber: PropTypes.number,
  isPrimary: PropTypes.bool,
  score: PropTypes.number
};

SelectOptionsIcon.propTypes = {
  backupNumber: PropTypes.number,
  featureFlags: PropTypes.object,
  isPrimary: PropTypes.bool,
  score: PropTypes.number,
  tested: PropTypes.bool
};

export default SelectOptionsIcon;
